import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';
import cogoToast from 'cogo-toast';

const PasswordForgetPage = () => (
	<div>
		<nav className="navbar navbar-dark bg-blue">
			<span className="navbar-brand">Forgot Password</span>
		</nav>
		<div className="container-fluid py-3" style={{backgroundColor: "#f2f2f2"}}>
			<div className="card mb-3">
				<div className="card-body">
					<PasswordForgetForm />
				</div>
			</div>
		</div>
		
	</div>
);

const INITIAL_STATE = {
	email: '',
	error: null,
};

class PasswordForgetFormBase extends Component {
	constructor(props) {
		super(props);
		this.state = { ...INITIAL_STATE };
	}
	
	componentDidMount(){
		document.title = 'Forgot Password';
	}

	onSubmit = event => {
		const { email } = this.state;

		this.props.firebase
			.doPasswordReset(email)
			.then(() => {
				this.setState({ ...INITIAL_STATE });

				// Show message
				cogoToast.success("Success! Please check your email for a link to reset your password.");
			})
			.catch(error => {
				this.setState({ error });

				// Show message
				cogoToast.error("Whoops, something went wrong. Please contact help@hotdraw.co.uk if the problem persists.");
		});

		event.preventDefault();
	};

	onChange = event => {
		this.setState({ [event.target.name]: event.target.value });
	};

	render() {
		const { email, error } = this.state;

		const isInvalid = email === '';

		return (
			<form onSubmit={this.onSubmit}>
				{error && <div>{error.message}</div>}
				
				<div className="form-group text-left">
					<label>Email Address *</label>
					<input
						name="email"
						value={this.state.email}
						onChange={this.onChange}
						type="text"
						className="form-control"
					/>
				</div>
					
				<button disabled={isInvalid} type="submit" className="btn btn-atb">Reset My Password</button>
			</form>
		);
	}
}

const PasswordForgetLink = () => (
	<p>
		<Link to={ROUTES.PASSWORD_FORGET}>Forgot Password?</Link>
	</p>
);

export default PasswordForgetPage;

const PasswordForgetForm = withFirebase(PasswordForgetFormBase);

export { PasswordForgetForm, PasswordForgetLink };